import React from "react";
import { Student } from "../types";
import { Table } from "semantic-ui-react";
import StudentListItem from "./StudentListItem";
import { useSelector } from "react-redux";
import { RootState } from "../../../app/store/configureStore";

interface Filter {
  students: Student[];
  onStudentUpdate: () => void;
}

const StudentList: React.FC<Filter> = ({ students, onStudentUpdate }) => {
  const { email } = useSelector((state: RootState) => state.currentUser);
  // Hack but good enough for now.
  const isLjaSchool = email === "ask+school@lja.lt";

  let lastUsedLetter = "";
  const renderSurnameLetter = (fullName: string) => {
    const parts = fullName.split(" ");
    const letter = parts[parts.length - 1][0];

    if (lastUsedLetter !== letter) {
      lastUsedLetter = letter;
      return <span>{letter}</span>;
    }

    return null;
  };

  return (
    <Table basic="very" className="student-list">
      <Table.Body>
        {students.map((student) => (
          <StudentListItem
            key={student.id}
            student={student}
            onStudentUpdate={onStudentUpdate}
            surnameLetterElement={renderSurnameLetter(student.contactInfo.fullName)}
            isLjaSchool={isLjaSchool}
          />
        ))}
      </Table.Body>
    </Table>
  );
};

export default StudentList;
